module.exports = __webpack_public_path__ + "img/langford-cutout.62db2114.png";